// extracted by mini-css-extract-plugin
export default {"inputWrap":"Input_inputWrap__4EYAN","input":"Input_input__E5rzA"};